module.exports = __webpack_public_path__ + "133532e7a255f6dbfc5f0a1ad6c80672.svg";